<template>
  <div :class="from!='introDetail'?'box2':'box2 no-padding'">
    <pageTitle
      title="实战项目  中级产品经理必经之路"
      text="辐射主流行业10+，上线企业级大型项目20+<br/>解决B端、C端等不同业务线需求"
      titleColor="#191c47"
      titColor="#666666"
    />

    <div class="subject-box">
      <div class="scorll-box6">
        <div class="nav-box">
          <div
            class="nav"
            :class="{ 'cur-nav': cur == index }"
            v-for="(item, index) in list"
            :key="index"
            @click="changeCur(index)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <img class="img" :src="item.img" alt />
          <div class="area">
            <div class="projectName">
              {{ item.nav }}
            </div>
            <div class="projectDesc">{{ item.into }}</div>
          </div>
          <div class="btn">查看全部</div>
        </swiper-slide>
      </swiper>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="block" v-if="show">
        <div class="block-tops">
          <div class="title">{{ list[this.cur].nav }}</div>
          <div class="close" @click="show = false"></div>
        </div>

        <div class="exp">{{ list[this.cur].into }}</div>

        <div class="tag">核心业务功能</div>
        <div class="exp">{{ list[this.cur].p1 }}</div>
        <div class="target">
          <p v-for="j in list[this.cur].core" :key="j">{{ j }}</p>
        </div>
        <div class="tag">{{ list[this.cur].tag }}</div>
        <div class="exp">{{ list[this.cur].p2 }}</div>
        <img
          :src="
            require(`../../../assets/coursePage/pm/box2/${this.cur + 1}.png`)
          "
          alt=""
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() { this.from=this.getQueryString("from")},

  data() {
    let that = this;
    return {
      show: false,
      from:'',
      list: [
        {
          title: "项目一",
          tag: "业务架构",
          nav: "帝可得",
          link: "https://pip.itcast.cn/pm-dkd",
          into: "帝可得作为一款智能售货机运营管理系统，运用现有技术对传统售货机进行改造，通过运营数据的采集和分析不断优化运营方案，便于实现商业价值。",
          p1: "B端商户智能化管理，C端用户快捷下单。学生学得透彻，知识运用自如。",
          p2: "对标前沿主流产品功能，还原企业真实业务场景，让你掌握复杂业务逻辑的技术实现技巧，开发事半功倍。",
          core: [
            "管理端：异常预警、人效统计、对账统计、订单管理、工单管理",
            "合作商端：分账统计、分账查询",
            "运营端：智能派单、人效排名、设备定位",
            "小程序端：附近设备、商品选购、交易支付",
          ],
          demo: ["管理端", "合作商端", "运营端", "小程序端"],
          urlList: ["", ""],
          img: require("../../../assets/coursePage/pm/box2/01.png"),
        },
        {
          title: "项目二",
          tag: "产品架构",
          nav: "品达物流",
          link: "https://pip.itcast.cn/pm-pdwl",
          into: "品达物流是一套智能化物流生态系统，覆盖城配、城际、快递等多种业务，涵盖订单分配、智能调度、线路规划、电子围栏、快递配送等主要功能，实现了整个物流链条的智能化监控和管理。",
          p1: "实现『某丰、某东物流、四通一达』主流快递公司TMS系统的核心功能。",
          p2: "完整物流体系，还原企业真实业务场景，让你掌握复杂业务逻辑的设计技巧。",
          core: [
            "车辆轨迹实时跟踪：基于车辆GPS系统的实时跟踪技术，确保配送全程可控",
            "智能路径规划：基于高复杂度的路径算法，实现一键自动规划车辆路径",
            "智慧车辆调度：多车辆、多线路的智能调度系统，实现车辆快捷调度，提升效率、降本增效",
            "智能电子围栏：智能绘制作业范围，方便快捷，轻松解决区域分配难题",
          ],
          demo: ["管理端", "客户端", "快递员端", "司机端"],
          urlList: ["", ""],
          img: require("../../../assets/coursePage/pm/box2/02.png"),
        },
        {
          title: "项目三",
          tag: "产品架构",
          nav: "餐掌柜",
          link: "https://pip.itcast.cn/pm-czg",
          into: "餐掌柜是互联网餐厅SaaS服务及运营平台，通过B端SaaS服务和C端产品，解决餐厅的效率、管理、营销、成本和顾客就餐体验等问题。",
          p1: "实现了智慧餐厅从点餐、用餐、统计全功能设计，学完可开发智慧餐厅平台。",
          p2: "多场景覆盖，多端融合业务体系，还原企业真实业务场景，让你掌握复杂业务逻辑的整体架构。",
          core: [
            "员工管理：独立账号体系，一键添加，账号状态便捷更改",
            "菜品管理：菜品分类上传，规格、价格、状态一目了然，便捷启售",
            "套餐管理：多菜品一键添加，优惠价格、售卖状态一目了然",
            "桌台管理：分区域添加桌台，配置每桌人数，满足自助点单需求",
            "挂账管理：店内就餐，账单按期统一结算，消费账单了如指掌",
            "门店设置：退菜原因、打折原因、赠菜原因、免单原因等平台备注便捷设置",
            "收银报表：日报、周报、月报，账目了解，多种图表展示运营状态",
            "门店管理：一个账号便捷管理集团门店，门店状态、所属品牌了如指掌",
            "品牌管理：集团品牌一键添加，专人负责",
          ],
          demo: ["门店端", "小程序端", "收银端", "运营端"],
          urlList: ["", ""],
          img: require("../../../assets/coursePage/pm/box2/03.png"),
        },
        {
          title: "项目四",
          tag: "业务架构",
          nav: "元蜂",
          link: "https://pip.itcast.cn/pm-yf",
          into: "元蜂WMS是仓储精细化管理系统，支持多仓库、多货主、多业务模式，可配置灵活策略和流程增值服务，进行全程可视化管理并提供仓配一体化解决方案。通过标准化、智能化的过程导向，对仓库完整管控，能够解决订单、作业以及仓库等问题。",
          p1: "实现某东物流、某鸟仓储、某世云仓三大物流公司仓储系统的核心功能，学完即可开发属于你的仓储管理系统！",
          p2: "传统仓储业务体系，还原企业真实业务场景，让你掌握复杂业务逻辑的技术实现技巧，开发事半功倍。",
          core: [
            "库存损益：基于库存变化，实时更新损益数据，实现货品库存的精细化管理",
            "盘点任务：定时任务自动下发，一盘、复盘指派到人，解决库存不准难题、确保货品数据准确",
            "入库收货：入库、收货、上架一站式闭环服务，收取货品数据清晰、一目了然",
            "出库拣货：出库、拣货、交接一站式闭环服务，出库货品准确无误、一货一码全程可溯",
            "货主管理：货主资料清晰可看，货品、库位准确可查，库存变化实时可见",
            "工作台：核心数据尽收眼底、增降趋势实时查看、快捷入口一键跳转",
          ],
          demo: ["管理端", "", "", ""],
          urlList: ["", ""],
          img: require("../../../assets/coursePage/pm/box2/04.png"),
        },
        {
          title: "项目五",
          tag: "功能架构",
          nav: "客达管家",
          link: "https://pip.itcast.cn/pm-hk",
          into: "客达管家是一款以客户为主的应用于市场销售的管理系统。辅助市场及销售人员对销售线索、商机、客户进行跟进转化，增加转化效率，实现销售线索的价值。",
          p1: "线索、商机、全流程跟进的CRM系统，学生学的透彻，知识运用自如。",
          p2: "客户管理系统业务全流程，还原企业真实场景，让你掌握复杂业务逻辑的设计技巧。",
          core: [
            "线索管理：线索导入自动清洗，线索入库智能分配，灵活的线索池回收，完善的跟进记录，提高整体跟进效率",
            "合同管理：合同管理安全可靠，合同内容了若指掌，方便快速完成合同签订",
            "转派管理：线索、商机灵活转派，从容应对种种突发事件",
            "权限管理：用户、角色、权限，经典RBAC模式，设计清晰，管理方便",
          ],
          demo: ["管理端", "", "", ""],
          urlList: ["", ""],
          img: require("../../../assets/coursePage/pm/box2/05.png"),
        },
      ],
      cur: 0,
      scroll: 0,
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box8",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("scorll-box6")[0].scrollLeft =
              this.realIndex * 96;
          },
          click(e) {
            if (e.target.className == "btn" || that.$refs.mySwiper) {
              that.show = true;
              that.mai("产品经理-就业课","查看全部",0,that.list[that.cur].nav)
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },

    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);

      this.cur = index;
      console.log(this.cur);
    },
    close() {
      this.showVideo = false;
    },
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 0px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/pm/box2/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .van-popup {
    max-height: calc(100vh - 80px);
  }
  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }

  .subject-box {
    position: relative;
    margin: 0px auto 0;
    // padding-bottom: 22px;
    width: 100%;

    overflow: hidden;
    .swiperwrap {
      width: 100%;

      .img {
        width: 561px;
        height: 321px;
        object-fit: contain;
        display: block;
        margin: 0 auto;
      }
      .area {
        padding: 0 40px;
        .draw {
          position: absolute;
          bottom: 0;
          background: url("../../../assets/coursePage/pm/box2/draw.png")
            no-repeat;
          width: 100%;
          height: 54px;
          margin-left: -43px;
          background-size: cover;
        }
        .projectName {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #1d2129;
          line-height: 48px;
          text-align: center;
          margin: 32px 0 16px;
        }
        .projectDesc {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 44px;
          background: linear-gradient(
            180deg,
            #86909c 0%,
            rgba(134, 144, 156, 0) 100%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;

          height: 88px;
          overflow: hidden;
        }
        .ability {
          width: 185px;
          height: 39px;
          background-color: rgba(69, 62, 255, 0.1);
          border-radius: 24px 19px 19px 0px;
          font-family: PingFangSC-Medium;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 39px;
          letter-spacing: 1px;
          color: rgba(69, 62, 255, 1);
          text-align: center;
          margin: 41px 0 28px;
        }
        .exp {
          font-family: PingFang SC;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 42px;
          letter-spacing: 0px;
          color: rgba(25, 28, 71, 1);
          margin-bottom: 20px;
        }
        .core {
          font-family: PingFang SC;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 42px;
          letter-spacing: 0px;
          color: rgba(25, 28, 71, 1);
          position: relative;
          padding-left: 48px;
          &::before {
            content: "";
            border-radius: 50%;

            position: absolute;
            display: block;
            left: 16px;
            top: 17px;
            width: 7px;
            height: 7px;
            background-color: rgba(69, 62, 255, 1);
          }
        }
      }

      .btn {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;

        line-height: 56px;
        text-align: center;
        margin: 24px auto 0;

        width: 180px;
        height: 56px;
        background-image: linear-gradient(
          90deg,
          rgba(54, 100, 252, 1) 0%,
          rgba(154, 151, 255, 1) 100%
        );
        border-radius: 32px;
      }
    }
    .scorll-box6 {
      overflow-x: scroll;
      transition: all 0.2s;
      width: 100%;

      height: 100%;

      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
        height: 0 !important;
        color: transparent;
      }
    }
  }
  .nav-box {
    padding: 48px 0 48px;
    display: flex;
    justify-content: space-between;
    margin: 0 32px 0 32px;
    position: relative;
    font-family: PingFangSC-Medium;
    font-size: 26px;
    font-weight: 400;
    color: #4e5969;
    color: #191c47;
    width: 100%;
    .nav {
      width: 138px;
      height: 68px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(95, 89, 255, 0.12);
      border-radius: 8px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 68px;
      text-align: center;
      margin-right: 20px;
    }
    .nav:last-child {
      margin-right: 32px;
    }
    .cur-nav {
      background: linear-gradient(227deg, #ba6eff 0%, #8883fe 100%);
      color: #ffffff;
      border-radius: 10px;
      color: #ffffff;
    }
  }

  .swiper-slide {
    .block {
      position: relative;
      margin: 0 auto;
      padding: 36px 32px;
      width: 686px;
      height: 688px;
      background: #ffffff;
      box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      border: 1px solid #ffffff;
      background-size: contain;
      background-repeat: no-repeat;
      // box-sizing: border-box;

      .open {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        width: 100%;
        height: 140px;
        // background: #fff;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 40%,
          #fff 100%
        );
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        box-sizing: border-box;

        img {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }

      overflow: hidden;
      box-sizing: border-box;

      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        height: 56px;
        .title {
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
        }

        .play-btn {
          display: flex;
          align-items: center;
          width: 180px;
          height: 56px;
          background: linear-gradient(313deg, #1fd7cd 0%, #65bcff 100%);
          box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
          border-radius: 32px;

          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;

          .play {
            margin-left: 8px;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 50%;
            box-shadow: 0px 0px 6px 0px #28a9ea;
            background-image: url("../../../assets/coursePage/ai/box8/play.png");
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .into {
        margin-bottom: 24px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
    }
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #d7effe;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 48px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      z-index: 10;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;

      height: 132px;
      padding-top: 16px;
      // margin: 48px 0 32px;
      box-sizing: border-box;

      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
    }
    img {
      width: 100%;
      margin-bottom: 74px;
    }
    .tag {
      margin-bottom: 24px;
      height: 56px;
      background: rgb(240, 240, 255);
      border-radius: 0px 32px 32px 24px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgb(95, 89, 255);
      line-height: 56px;
      padding: 0 24px;
      width: max-content;
    }

    .target {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;

      margin-bottom: 40px;

      p {
        line-height: 44px;
        padding-left: 15px;
        position: relative;
        &::before {
          content: "";
          width: 4px;
          height: 4px;
          background: #4e5969;

          border-radius: 50%;

          top: 20px;
          display: block;
          position: absolute;
          left: 0;
        }
      }
    }
  }
}
.no-padding{
   padding-top: 80px;
}
</style>
